<template>
  <div>
    <OpenOrdersModal
      :readOnly="true"
      :id="null"
      :valDeadlineWorkshopOverride="null"
    />
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Facturas</h2>
          <p>
            En este apartado se pueden ver las facturas clasificadas por
            trimestre fiscal.
          </p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de facturas</h3>
              <v-server-table
                name="invoices"
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <!-- <template v-slot:modified_at="props">
                  <span>{{ props.row.modified_at }}</span>
                </template> -->

                <template v-slot:order_id="props">
                  <b-link
                    v-if="props.row.order"
                    :to="{
                      name: 'AdminOrdersEditScreen',
                      params: { id: props.row.order.id },
                    }"
                    >{{ props.row.order.id }}</b-link
                  >
                  <span v-else>-</span>
                </template>

                <template v-slot:workshoporder_id="props">
                  <b-link
                    v-if="props.row.workshoporder"
                    :to="{
                      name: 'AdminWorkshopOrdersEditScreen',
                      params: { id: props.row.workshoporder.id },
                    }"
                    >{{ props.row.workshoporder.id }}</b-link
                  >
                  <span v-else>-</span>
                </template>

                <!-- <template v-slot:date="props">
                  <span>{{ props.row.order.modified_at | formatDate() }}</span>
                </template> -->

                <template v-slot:year="props">
                  <span>{{ props.row.created_at | formatDate('YYYY') }}</span>
                </template>

                <template v-slot:quarter="props">
                  <span>T{{ props.row.created_at | formatQuarter() }}</span>
                </template>

                <template v-slot:created_at="props">
                  <span>{{ props.row.created_at }}</span>
                </template>

                <template v-slot:company_name="props">
                  <span>{{
                    (props.row.order || props.row.workshoporder)
                      .billing_address_full &&
                    (props.row.order || props.row.workshoporder)
                      .billing_address_full.company_name
                      ? (props.row.order || props.row.workshoporder)
                          .billing_address_full.company_name
                      : '-'
                  }}</span>
                </template>

                <template v-slot:company_id="props">
                  <span>{{
                    (props.row.order || props.row.workshoporder)
                      .billing_address_full &&
                    (props.row.order || props.row.workshoporder)
                      .billing_address_full.company_id
                      ? (props.row.order || props.row.workshoporder)
                          .billing_address_full.company_id
                      : '-'
                  }}</span>
                </template>

                <template v-slot:customer_name="props">
                  <span
                    >{{
                      (props.row.order || props.row.workshoporder).customer_info
                        .first_name
                    }}
                    {{
                      (props.row.order || props.row.workshoporder).customer_info
                        .last_name
                    }}</span
                  >
                </template>

                <template v-slot:tax_base="props">
                  <span>{{ props.row.tax_base.toFixed(2) }} €</span>
                </template>

                <template v-slot:tax="props">
                  <span>{{ props.row.tax.toFixed(2) }} €</span>
                </template>

                <template v-slot:total_price="props">
                  <span v-if="props.row.is_partial"
                    >{{ props.row.amount }} €</span
                  >
                  <span v-else>{{ props.row.total }} €</span>
                </template>

                <template v-slot:status="props">
                  <span>{{ props.row.status | formatStatus }}</span>
                </template>

                <template v-slot:quote="props">
                  <b-link
                    :to="{
                      name: 'AdminQuotesEditScreen',
                      params: { id: props.row.quote },
                    }"
                    >{{ props.row.quote }}</b-link
                  >
                </template>

                <template v-slot:actions="props">
                  <span
                    :id="'btn-' + props.row.id"
                    class="d-inline-block"
                    tabindex="0"
                  >
                    <b-button
                      @click="downloadInvoice(props.row.id)"
                      :id="'btn-' + props.row.id"
                      size="sm"
                      variant="outline-primary"
                      class="mr-2"
                      ><b-icon
                        icon="file-earmark-check"
                        aria-hidden="true"
                      ></b-icon>
                      <!-- {{
                      props.row.invoice_id
                        ? 'Factura (' + props.row.invoice_id + ')'
                        : 'Factura'
                    }} -->
                      Descargar
                    </b-button>
                    <b-button
                      @click="removeInvoice(props.row.id)"
                      size="sm"
                      variant="outline-danger"
                      class="mr-2"
                      ><b-icon icon="trash" aria-hidden="true" />
                    </b-button>
                  </span>
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';
import OpenOrdersModal from '@/admin/components/orders/OpenOrdersModal.vue';

import store from '@/admin/store.js';

import moment from 'moment';
import 'moment/locale/es';

export default {
  name: 'AdminInvoicesScreen',
  props: ['customerid'],
  components: { OpenOrdersModal },
  data() {
    return {
      table: {
        url: this.customerid
          ? uris.invoicesByCustomerIdURI(this.customerid)
          : uris.invoicesURI,
        selected: [],
        allSelected: false,
        columns: [
          'id',
          'order_id',
          'workshoporder_id',
          // 'date',
          'year',
          'quarter',
          'customer_name',
          'company_name',
          'company_id',
          'tax_base',
          'tax',
          'total_price',
          'actions',
        ],
        options: {
          saveState: this.customerid ? false : true,
          sortable: [],
          filterable: false,
          headings: {
            id: '# Factura',
            date: 'Fecha',
            order_id: '# Venta',
            workshoporder_id: '# Pedido',
            customer_name: 'Nombre',
            year: 'Año',

            total_price: 'Total',
            tax_base: 'BI',
            tax: 'IVA/IGIC/IPSI',
            quarter: 'Trimestre',

            'order.quote': '# Presupuesto',

            company_name: 'Empresa',
            company_id: 'NIF',

            actions: 'Acciones',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {},
  filters: {
    formatStatus: function (value) {
      return {
        Received: 'Recibido',
        Workshop: 'En taller',
        Finished: 'Terminado',
        Sent: 'Enviado',
        Delivered: 'Entregado',
      }[value];
    },
    formatDate: function (value, format) {
      return moment(value, 'DD-MM-YYYY HH:mm').format(format);
    },
    formatQuarter: function (value) {
      return moment(value, 'DD-MM-YYYY HH:mm').quarter();
    },
    formatCurrency(val) {
      return val.toFixed(2);
    },
  },
  methods: {
    downloadInvoice(invoiceId) {
      actions.downloadInvoice(invoiceId).then((x) => {
        let fileName = 'test.pdf';

        const contentDisposition = x.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }

        let blob = new Blob([x.data], { type: 'application/pdf' });

        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
    },

    // removeSelected() {
    //   this.table.selected.map((x) => {
    //     this.removeOrder(x);
    //   });
    // },
    removeInvoice(id) {
      if (
        confirm(
          '¿Estás seguro que deseas eliminar la factura número ' + id + '?'
        )
      ) {
        actions.deleteInvoice(id).then((x) => {
          this.$refs.table.refresh();
        });
      }
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.reference)
        : [];
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
